import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=55d72f42&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style1 from "./detail.vue?vue&type=style&index=1&lang=less&"
import style2 from "./detail.vue?vue&type=style&index=2&id=55d72f42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d72f42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55d72f42')) {
      api.createRecord('55d72f42', component.options)
    } else {
      api.reload('55d72f42', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=55d72f42&scoped=true&", function () {
      api.rerender('55d72f42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/scenicTutorials/detail.vue"
export default component.exports